"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/* tslint:disable:no-empty */
var noop = exports.noop = function noop() {};
exports.default = noop;
